import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusSquareFilled, ExpandAltOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Button, Form, FormInstance, Select, DatePicker, Space, Spin } from 'antd';
import dayjs from 'dayjs';
import { AlignType } from 'rc-table/lib/interface';

import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { hasText } from "../../../utils/utilsFunctions";
import { IMandatoCaracteristica, ICaracteristicasMandato } from "../Componentes/InterfaceMandato";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";


interface IProps {
  form: FormInstance<any>;
  mandatoCaracteristica: IMandatoCaracteristica[];
  setMandatoCaracteristica: React.Dispatch<React.SetStateAction<IMandatoCaracteristica[]>>;
  caracteristicasMandato: ICaracteristicasMandato[];
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
  setMandatoCaracteristicaTouched?: React.Dispatch<React.SetStateAction<boolean>>;
  csCategoria?: number; // 1 : Diretor Executivo / 2 : Conselheiro Deliberativo / 3 : Conselheiro Fiscal
}

const { Option } = Select;


const DirigenteCaracteristica = ({ form, mandatoCaracteristica, setMandatoCaracteristica, caracteristicasMandato, manter, csCategoria }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [exibirModalCarac, setExibirModalEx] = useState(false);
  const [exibirCaracteristicaMandato, setExibirCaracteristicaMandato] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [dadosValidados, setDadosValidados] = useState(false);


  useEffect(() => {
    if (mandatoCaracteristica.length === 0) {
      setExibirCaracteristicaMandato("none")
    } else {
      setExibirCaracteristicaMandato("inline")
    }
  }, [mandatoCaracteristica]);


  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);


  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
    }
  }, [estadoModal]);


  const controleDaGrid = (botao: string) => {
    if (!hasText(form.getFieldValue("matriculaEfpc"))) {
      mostrarInfo("Não é possível incluir nova característica", "Entidade não informada");
    } else if (!hasText(form.getFieldValue("nmCargo")) && csCategoria === 1) {
      mostrarInfo("Não é possível incluir nova característica", "Nome do cargo não informado");
    } else if (!hasText(form.getFieldValue("dtInicioMandato"))) {
      mostrarInfo("Não é possível incluir nova característica", "Datas de mandato não informadas");
    } else {
      if (botao === "cancelar") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalEx(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }

    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarCaracteristica = () => {

    form
      .validateFields([
        "idCaracteristicaMandato",
        "nmCaracteristica",
        "dtInicio",
        "dtFimCarac",
      ])
      .then(() => {
        setDadosValidados(true);
        controleDaGrid("incluir");
        setDadosCaracteristica();
      })
      .catch((error) => {
        if (!dadosValidados) {
          errorMessage("Campo obrigatório não preechido ou não validado");
        } else {
          errorMessage(error.message);
        }
        setDadosValidados(false);
      });

  };

  const setDadosCaracteristica = () => {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setMandatoCaracteristica(pre => {
        return pre.map(carac => {
          if (carac.emEdicao) {
            return ({
              idMandatoCaracteristica: estadoModal === 3 ? Number(form?.getFieldValue("idMandatoCaracteristica")) : -1,
              idCaracteristicaMandato: form?.getFieldValue("idCaracteristicaMandato"),
              nmCaracteristica: form?.getFieldValue("nmCaracteristica")?.toUpperCase(),
              dtInicio: form?.getFieldValue("dtInicio") ? dayjs(form?.getFieldValue("dtInicio")).format("YYYY-MM-DD") : "",
              dtFim: form?.getFieldValue("dtFimCarac") ? dayjs(form?.getFieldValue("dtFimCarac")).format("YYYY-MM-DD") : "",
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return carac
          }
        })
      });
    } else {
      setMandatoCaracteristica([
        ...mandatoCaracteristica,
        {
          idMandatoCaracteristica: estadoModal === 3 ? Number(form?.getFieldValue("idMandatoCaracteristica")) : -1,
          idCaracteristicaMandato: form?.getFieldValue("idCaracteristicaMandato"),
          nmCaracteristica: form?.getFieldValue("nmCaracteristica")?.toUpperCase(),
          dtInicio: form?.getFieldValue("dtInicio") ? dayjs(form?.getFieldValue("dtInicio")).format("YYYY-MM-DD") : "",
          dtFim: form?.getFieldValue("dtFimCarac") ? dayjs(form?.getFieldValue("dtFimCarac")).format("YYYY-MM-DD") : "",
          statusReg: 1,
          emEdicao: false,
          touched: true,
        },
      ]);
    }
    limpaDados();
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const limpaDados = () => {
    form.resetFields([
      "idMandatoCaracteristica",
      "idCaracteristicaMandato",
      "nmCaracteristica",
      "dtInicio",
      "dtFimCarac",
      "ativo",
    ]);
  }

  const setFieldsDetalharEditar = (ICaracteristica: IMandatoCaracteristica) => {
    form.setFieldsValue({
      "idMandatoCaracteristica": ICaracteristica.idMandatoCaracteristica ? ICaracteristica.idMandatoCaracteristica : -1,
      "idCaracteristicaMandato": ICaracteristica.idCaracteristicaMandato ? ICaracteristica.idCaracteristicaMandato : -1,
      "nmCaracteristica": ICaracteristica.caracteristicasMandato ? ICaracteristica.caracteristicasMandato.nmCaracteristica : ICaracteristica.nmCaracteristica,
      "dtInicio": ICaracteristica.dtInicio ? dayjs(ICaracteristica.dtInicio) : undefined,
      "dtFimCarac": ICaracteristica.dtFim ? dayjs(ICaracteristica.dtFim) : undefined,
    });
  }

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Característica",
      dataIndex: "",
      render: (ICarac: IMandatoCaracteristica) => <>{ICarac.caracteristicasMandato ? ICarac.caracteristicasMandato.nmCaracteristica : ICarac.nmCaracteristica}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Data Inicial",
      dataIndex: "",
      render: (ICarac: IMandatoCaracteristica) => <>{dayjs(ICarac.dtInicio).format("DD/MM/YYYY")}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Data Final",
      dataIndex: "",
      render: (ICarac: IMandatoCaracteristica) => <>{ICarac.dtFim ? dayjs(ICarac.dtFim).format("DD/MM/YYYY") : undefined}</>,
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (ICarac: IMandatoCaracteristica) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(2); // SET O MODO DETALHAR
                  setFieldsDetalharEditar(ICarac);
                }}
              />
            </div>

            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  setFieldsDetalharEditar(ICarac);
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  mandatoCaracteristica.forEach(carac => {
                    if (carac === ICarac) {
                      carac.statusReg = 1;
                      carac.touched = true;
                      carac.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      carac.emEdicao = false;
                    }
                  })
                  ICarac.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (ICarac?.idMandatoCaracteristica && ICarac?.idMandatoCaracteristica < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setMandatoCaracteristica(mandatoCaracteristica.filter((carac) => carac !== ICarac));
                }}
              />
            </div>

            <div style={{ display: (ICarac?.idMandatoCaracteristica && ICarac?.idMandatoCaracteristica > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (ICarac?.statusReg === 1 || ICarac?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    ICarac.touched = true; // MARCA O REGISTRO ALTERADO.
                    ICarac.statusReg = (ICarac.statusReg === 1 ? 2 : 1);
                    setMandatoCaracteristica(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(carac => {
                        if (carac.idMandatoCaracteristica === ICarac.idMandatoCaracteristica) {
                          return ICarac;
                        } else {
                          return carac;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (ICarac?.statusReg === 1 || ICarac?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    ICarac.touched = true; // MARCA O REGISTRO ALTERADO.
                    ICarac.statusReg = (ICarac.statusReg === 1 ? 2 : 1);
                    setMandatoCaracteristica(pre => {
                      return pre.map(carac => {
                        if (carac.idMandatoCaracteristica === ICarac.idMandatoCaracteristica) {
                          return ICarac;
                        } else {
                          return carac;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },
  ];

  const handleCancel = () => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
    controleDaGrid("cancelar");
    form.resetFields([
      "idCaracteristicaMandato",
      "nmCaracteristica",
      "dtInicio",
      "dtFimCarac",
      "ativo",
    ]);
  };


  const handlerCaracteristicaMandato = async (value: any) => {
    form.setFieldsValue({
      "nmCaracteristica": value.children,
      "idCaracteristicaMandato": value.key,
    });
  };

  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirCaracteristica"
        type="primary"
        shape="round"
        onClick={() => {
          limpaDados();
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirCaracteristica");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Característica
      </Button>

      <>
        <Modal title="Incluir Característica" open={exibirModalCarac}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarCaracteristica}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >
          <Spin spinning={loading} tip={tipLoading}>
            <>
              <Row>
                <Col xs={24} sm={24}>
                  <Form.Item label='Característica'
                    name='nmCaracteristica'
                    labelCol={{ span: 12 }}
                    labelAlign="left"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "A característica é obrigatória",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: 600 }}
                      showSearch
                      filterOption
                      optionFilterProp='children'
                      placeholder='Característica'
                      disabled={estadoModal === 2}
                      onChange={(_, index) => {
                        handlerCaracteristicaMandato(index);
                      }}
                    >
                      {caracteristicasMandato?.map((e: ICaracteristicasMandato) => (
                        <Option key={e.idCaracteristicaMandato} value={e.idCaracteristicaMandato}>
                          {e.nmCaracteristica}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={8}>
                  <Form.Item label="Data Inicial"
                    name="dtInicio"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "Data inicial obrigatória",
                      },
                      {
                        validator: async (_, startDatetime) => {
                          let dtInicioMandato = form.getFieldValue("dtInicioMandato");
                          if (dtInicioMandato && startDatetime) {
                            startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                            dtInicioMandato = dayjs(dtInicioMandato).format("YYYY-MM-DD")
                            if (startDatetime < dtInicioMandato) {
                              return Promise.reject(
                                "A data não pode ser anterior à Data Inicial do Mandato"
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabled={estadoModal === 2}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item label="Data Final"
                    name="dtFimCarac"
                    colon={false}
                    rules={[
                      {
                        validator: async (_, endDatetime) => {
                          let startDatetime = form.getFieldValue("dtInicio");
                          if (startDatetime && endDatetime) {
                            endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                            startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                            if (endDatetime < startDatetime) {
                              return Promise.reject(
                                "A Data Final não pode ser anterior à Data Inicial"
                              );
                            }
                          }
                        },
                      },
                      {
                        validator: async (_, endDatetime) => {
                          let dtFimMandato = form.getFieldValue("dtFimMandato");
                          if (dtFimMandato && endDatetime) {
                            endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                            dtFimMandato = dayjs(dtFimMandato).format("YYYY-MM-DD")
                            if (endDatetime > dtFimMandato) {
                              return Promise.reject(
                                "A data não pode ser posterior à Data Final do Mandato"
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabled={estadoModal === 2}
                    />
                  </Form.Item>
                </Col>

              </Row>

            </>
          </Spin>
        </Modal>

      </>

      <Row style={{ display: exibirCaracteristicaMandato }}>
        <Col
          xs={24}
          xl={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" showHeader={true} columns={columns} dataSource={mandatoCaracteristica} pagination={false} />
        </Col>
      </Row>

    </>
  )
};

export default DirigenteCaracteristica;